import { PRODUCT_OPERATIONS } from '../operations'

const withCountryCode = phone => (phone?.startsWith('+91') ? phone : `+91${phone || ''}`)

const asObject = raw => (typeof raw === 'object' && raw !== null ? raw : null)

const emailOtpRequestData = ({ email }) => ({ email_id: email })

const emailOtpResponse = raw => {
  const payload = asObject(raw)
  const data = payload?.data ?? {}
  return {
    ok: payload?.success !== false,
    message: payload?.message,
    expiresInSeconds: data.expires_in_seconds,
    canResendAfterSeconds: data.can_resend_after_seconds,
    otpId: payload?.otpId ?? data.otpId ?? data.otp_id,
    raw
  }
}

const emailOtpVerifyResponse = raw => {
  const payload = asObject(raw)
  const data = payload?.data ?? {}
  return {
    ok: true,
    message: payload?.message,
    email: data.email ?? data.email_id,
    verifiedAt: data.verified_at ?? data.verifiedAt,
    verificationStatus: data.verification_status ?? data.verificationStatus,
    raw
  }
}

const DEFAULT_LP_HEADERS = {
  accept: 'application/json',
  'Content-Type': 'application/json'
}

/** One entry per LP operation — HTTP method, wire request, normalized response. */
const LP_OPERATION_CONFIG = {
  [PRODUCT_OPERATIONS.AUTHENTICATE]: {
    method: 'POST',
    requestData: () => ({}),
    response: raw => ({ isActive: !!raw?.status, muid: raw?.muid })
  },
  [PRODUCT_OPERATIONS.SEND_OTP]: {
    method: 'POST',
    requestData: ({ phone }) => ({ phone }),
    response: raw => ({
      ok: true,
      otpId: raw?.otp_id ?? raw?.otpId,
      raw
    })
  },
  [PRODUCT_OPERATIONS.VERIFY_LOGIN]: {
    method: 'POST',
    requestData: ({ code, phone, otpId }) => ({
      phone: withCountryCode(phone),
      code,
      otpId
    }),
    response: raw => ({
      ok: true,
      muid: raw?.muid ?? raw?.data?.muid ?? raw?.userId ?? raw?.data?.userId ?? null,
      raw
    })
  },
  [PRODUCT_OPERATIONS.GENERATE_EMAIL_OTP]: {
    method: 'POST',
    requestData: emailOtpRequestData,
    response: emailOtpResponse
  },
  [PRODUCT_OPERATIONS.RESEND_EMAIL_OTP]: {
    method: 'POST',
    requestData: emailOtpRequestData,
    response: emailOtpResponse
  },
  [PRODUCT_OPERATIONS.VERIFY_EMAIL_OTP]: {
    method: 'POST',
    requestData: ({ email, otp, otpId }) => ({ email_id: email, otp, otpId }),
    response: emailOtpVerifyResponse
  }
}

const getConfig = operation => {
  const config = LP_OPERATION_CONFIG[operation]
  if (!config) {
    throw new Error(`Operation "${operation}" is not supported for LP`)
  }
  return config
}

export const lpAdapter = {
  buildHeaders: () => ({ ...DEFAULT_LP_HEADERS }),
  buildRequest: (operation, input = {}) => getConfig(operation).requestData(input),
  normalizeResponse: (operation, raw) => getConfig(operation).response(raw),
  getHttpMethod: operation => getConfig(operation).method
}
